import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { makeStyles } from "@material-ui/core/styles";
import { useHeight, useWidth } from "common-frontend-components";
import { Fade } from "@mui/material";
import { globalAppConfigStore } from "../../stores/appConfig/globalAppConfigStore";
export const BodyBackground = () => {
    const width = useWidth();
    const height = useHeight();
    const size = width > height ? width : height;
    const config = globalAppConfigStore.useComponent('body-background');
    const useStyles = makeStyles({
        svgBackground: {
            backgroundSize: 'cover',
            background: (config?.params?.background || "black").replace("$url", config?.url || "") || undefined,
            animation: "$slideAnimation 400s linear infinite",
            display: 'inline-block',
            position: 'fixed',
            top: '0',
            left: '0',
            // opacity: 0.8,
            overflow: 'hidden',
            width: size,
            height: size,
            pointerEvents: 'none',
            zIndex: -1,
        },
        "@keyframes slideAnimation": {
            from: {
                transform: 'translate3d(0, 0, 0)',
            },
            to: {
                transform: `translate3d(0, -${size}px, 0)`,
                borderRadius: 'none',
            },
        },
    });
    const classes = useStyles();
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.svgBackground, style: { zIndex: -2, backgroundColor: config?.params?.bodyBaseBackgroundColor } }, void 0), _jsx(Fade, { in: true, timeout: 2500, children: _jsxs("div", { children: [_jsx("div", { className: classes.svgBackground }, void 0), _jsx("div", { className: classes.svgBackground, style: { top: size - 1 } }, void 0)] }, void 0) }, void 0)] }, void 0));
};
export const BodyBackgroundContainer = ({ children }) => {
    const config = globalAppConfigStore.useComponent('body-background');
    const useBackgroundContainerStyles = makeStyles({
        svgBackgroundContainer: {
            position: 'relative',
            width: '100%',
            verticalAlign: 'middle',
        },
        childrenContainer: {
            position: 'relative',
            zIndex: 1,
            backgroundColor: config?.params?.childrenContainerBackgroundColor,
            width: '100%',
            minHeight: '100vh',
        },
    });
    const classes = useBackgroundContainerStyles();
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classes.svgBackgroundContainer, children: _jsx(BodyBackground, {}, void 0) }, void 0), _jsx("div", { className: classes.childrenContainer, children: children }, void 0)] }, void 0));
};
//# sourceMappingURL=BodyBackgroundContainer.js.map